import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const LinkHorizontal = Styled(
  createSvgIcon(
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.17992 8C1.65325 7.36667 1.33325 6.55333 1.33325 5.66667C1.33325 3.65333 2.97992 2 4.99992 2H8.33325C10.3466 2 11.9999 3.65333 11.9999 5.66667C11.9999 7.68 10.3533 9.33333 8.33325 9.33333H6.66659"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.82 8.00033C14.3467 8.63366 14.6667 9.44699 14.6667 10.3337C14.6667 12.347 13.02 14.0003 11 14.0003H7.66667C5.65333 14.0003 4 12.347 4 10.3337C4 8.32033 5.64667 6.66699 7.66667 6.66699H9.33333"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>,
    "LinkHorizontal",
  ),
);

export default LinkHorizontal;
